<form [formGroup]="form">
  <h4>{{''|i18n:'decline-reason'}}</h4>
  <textarea formControlName="declineReason"></textarea>
  @if (invalid()) {
    <app-error-field [errorMessage]="''| i18n:'decline-reason-is-required-and-max-length-is-500'"></app-error-field>
  }

  <div>
    <button class="col-4" (click)="declineSpecialRequest()" [disabled]="!form.valid">{{''|i18n:'save'}}</button>
  </div>

</form>
